import { useRef } from 'react';

export const useScrollLock = () => {
    const scrollOffset = useRef(0);

    const lockScroll = () => {
        scrollOffset.current = window.scrollY;
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.height = '100vh';
    };

    const unlockScroll = () => {
        document.documentElement.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('height');
        window.scrollTo({ top: scrollOffset.current, behavior: 'auto' });
    };

    return { lockScroll, unlockScroll };
};
